var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 351.451 135.575",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_1236_1233_0",
    x1: 298.684296,
    y1: 1.789795,
    x2: 298.684296,
    y2: 132.698883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_1236_1234_0",
    x1: 175.300354,
    y1: 0,
    x2: 175.300354,
    y2: 135.575287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_1236_1235_0",
    x1: 52.766357,
    y1: 1.789795,
    x2: 52.766357,
    y2: 132.698883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDEB"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M245.918 109.688L245.918 87.8906L300.57 1.78979L319.363 1.78979L319.363 31.9603L308.24 31.9603L273.787 86.4844L273.787 87.5071L351.451 87.5071L351.451 109.688L245.918 109.688ZM308.752 132.699L308.752 103.04L309.264 93.3878L309.264 1.78979L335.215 1.78979L335.215 132.699L308.752 132.699Z",
    fill: "url(#paint_linear_1236_1233_0)",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M175.301 135.575C164.307 135.533 154.846 132.827 146.92 127.457C139.037 122.088 132.963 114.311 128.703 104.126C124.484 93.9418 122.396 81.6904 122.438 67.3722C122.438 53.0966 124.547 40.9304 128.766 30.8736C133.027 20.8168 139.1 13.1676 146.984 7.92615C154.91 2.64203 164.35 0 175.301 0C186.252 0 195.67 2.64203 203.553 7.92615C211.479 13.2102 217.572 20.8807 221.834 30.9375C226.096 40.9517 228.205 53.0966 228.162 67.3722C228.162 81.733 226.031 94.0057 221.771 104.19C217.553 114.375 211.5 122.152 203.617 127.521C195.734 132.891 186.295 135.575 175.301 135.575ZM175.301 112.628C182.801 112.628 188.787 108.857 193.262 101.314C197.736 93.7713 199.953 82.4574 199.91 67.3722C199.91 57.4432 198.887 49.1761 196.842 42.571C194.838 35.9659 191.984 31.0014 188.275 27.6776C184.611 24.3537 180.287 22.6918 175.301 22.6918C167.844 22.6918 161.877 26.4205 157.402 33.8779C152.928 41.3352 150.67 52.5 150.627 67.3722C150.627 77.429 151.629 85.8239 153.631 92.5568C155.678 99.2472 158.553 104.276 162.26 107.642C165.969 110.966 170.314 112.628 175.301 112.628Z",
    fill: "url(#paint_linear_1236_1234_0)",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 109.688L0 87.8906L54.6523 1.78979L73.4453 1.78979L73.4453 31.9603L62.3223 31.9603L27.8691 86.4844L27.8691 87.5071L105.533 87.5071L105.533 109.688L0 109.688ZM62.834 132.699L62.834 103.04L63.3457 93.3878L63.3457 1.78979L89.2969 1.78979L89.2969 132.699L62.834 132.699Z",
    fill: "url(#paint_linear_1236_1235_0)",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.02903c345335aa0d2c252788ace2747d.svg";
export { ForwardRef as ReactComponent };